@if (apiAccounts && apiAccounts.length >= 2) {
  <select (change)="updateApiKey()"
    [(ngModel)]="selectedApiKey"
    [disabled]="noApiAccount"
    class="form-control">
    @if (noApiAccount) {
      <option>{{ 'document.no_api_account' | translate }}</option>
    }
    @for (apiAccount of apiAccounts; track apiAccount) {
      <option [value]="apiAccount.apiKey">{{ apiAccount.name}}</option>
    }
  </select>
}
